import { WidgetSettingFC } from "types/Setting";

interface InformationProps {
  info: string;
}

export const InformationSetting: WidgetSettingFC<string, InformationProps> = ({
  info: { info },
}) => {
  return (
    <>
      <p dangerouslySetInnerHTML={{ __html: info }} />
      <br />
    </>
  );
};
